import { Factory } from '../Factory';
import { Service } from '../Service';

namespace app.services.exporting {

  export class LoadFileFormatService extends Service<any> {
    constructor(resource: any, rootScope: IRootScope, configService, resourceWrapperService) {
      super({resource, rootScope, resourceWrapperService});

      let fileFormatResource = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/loadFileFormat/:id`,
        {id: "@id", projectId: "@projectId"},
        {update: {method: "PUT"}});

      this.itemResource = this.resourceWrapperService.WrapActions(fileFormatResource);
    }
  }


  frontendApp.factory("LoadFileFormatService", ["$resource", "$rootScope", "ConfigService", "ResourceWrapperService", Factory.Create(LoadFileFormatService)]);
}
